import { render, staticRenderFns } from "./CreadorActividadesForm.vue?vue&type=template&id=5cc5f72a"
import script from "./CreadorActividadesForm.vue?vue&type=script&lang=js"
export * from "./CreadorActividadesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports